import { useEffect } from 'react';
import { setupMixpanel } from './useMixPanel';
export const useAnalyticsSetup = (appName: string) => {
  useEffect(() => {
    localStorage.setItem('analytics_app_name', appName);
    setupMixpanel();
    //setup firebase here when integrating
  }, [appName]);
};
